import { axiosPath } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    start_transfer_list: [],
    end_transfer_list: [],
    transfer_set_list: [],
    select_start: {},
    is_loading_price: false
  },
  mutations: {
    resetState(state) {
      state.start_transfer_list = [];
    },
    getEndTransferList(state) {
      state.end_transfer_list = JSON.parse(
        JSON.stringify(state.start_transfer_list)
      );
    },
    getSelectedTransfer(state, data) {
      state.select_start = data;
    },
    getStartTransferList(state, data) {
      state.start_transfer_list = data;
    },
    getTransferRateList(state, data) {
      state.transfer_set_list = data;
    },
    takeTransferPrice(state, data) {
      for (let val_1 of state.end_transfer_list) {
        for (let val_2 of data) {
          if (
            val_2.transport_sub_district_end_id ==
            val_1.transport_sub_district_start_id
          ) {
            val_1.transport_price = val_2.transport_price;
            val_1.transport_id = val_2.transport_id;
          }
        }
      }
    },
    isLoadingPrice(state, data) {
      state.is_loading_price = data;
    }
  },
  actions: {
    async updateTransferRate({ rootState, dispatch, commit }, form) {
      let url = null;
      if (form.transport_id) {
        url =
          rootState.api_urls.fetchFoodRateBack_updateTransferRate +
          form.transport_id;
        let res = await dispatch(
          "fetchGeneral/axiosPathPutData",
          { url, form },
          { root: true }
        );
        if (typeof res == "boolean" && res == false) {
          return 3;
        } else {
          return 2;
        }
      } else {
        url = rootState.api_urls.fetchFoodRateBack_createTransferRate;
        let res = await dispatch(
          "fetchGeneral/axiosPathPostData",
          { url, form },
          { root: true }
        );
        if (typeof res == "boolean" && res == false) {
          return 3;
        } else {
          commit("takeTransferPrice", res);
          return 2;
        }
      }
    },
    async getTransferRateList(
      { commit, rootState, dispatch },
      sub_district_id
    ) {
      let url =
        rootState.api_urls.fetchFoodRateBack_getTransferRateList +
        sub_district_id;
      commit("isLoadingPrice", true);
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        commit("isLoadingPrice", false);
        return false;
      } else {
        commit("takeTransferPrice", res);
        commit("isLoadingPrice", false);
        return res;
      }
    },
    async getStartTransferList({ commit, rootState, dispatch }) {
      let url = rootState.api_urls.fetchFoodRateBack_getStartTransferList;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return err;
      } else {
        commit("getStartTransferList", res);
        return " No data available";
      }
    }
  }
};
